<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <table style="width: 100%">
      <tr>
        <th></th>
        <th v-for="diaSemana in semana.dias" v-bind:key="diaSemana.diaNumero">
          {{diaSemana.diaEtiqueta}}
        </th>
      </tr>

      <tr>
        <th></th>
        <th v-for="diaSemana in semana.dias" v-bind:key="diaSemana.diaNumero">
          <table style="width: 100%;border:solid 1px;">
            <tr>
              <td v-for="numeroSala in casillasSalas" v-bind:key="numeroSala" :style="ancho">
                <div :style="ancho">
                  <div class="titulo-sala">{{numeroSala}}</div>
                </div>
              </td>
              <td :style="ancho">
                <div :style="ancho">
                  <div class="titulo-sala" :style="ancho">E1</div>
                </div>
              </td>
              <td :style="ancho">
                <div :style="ancho">
                  <div class="titulo-sala" :style="ancho">E2</div>
                </div>
              </td>
            </tr>
          </table>
        </th>
      </tr>
      <tr v-for="hora in semana.horas" v-bind:key="hora.posicion" class="casilla horas" :style="estiloLineaHora(hora)">
        <td>{{hora.horaEtiqueta}}</td>

        <td v-for="(casilla, indexCasilla) in casillas[hora.posicion]" v-bind:key="casilla.diaSemana"
            :class="[indexCasilla%2 === 0 ? 'agenda-calendario-dia-par' : 'agenda-calendario-dia-impar', casilla.esfechaActual?'  agenda-calendario-dia-actual':'']">
          <div>
            <table width="100%">
              <tr>
                <td v-for="sala in casilla.salas" v-bind:key="sala.numeroSala" :style="ancho"
                    class="agenda-calendario-sala">
                  <div :style="'background-color:'+sala.color">
                    
                    <horario-sillon-doctores
                            :style="ancho"
                            @consultarDetalle="consultarDetalle"
                            @activarDesactivarHorario="activarDesactivarHorario"
                            @bloquear="bloquear"
                            @desbloquear="desbloquear"
                            @reasignarDoctor="reasignarDoctor"
                            :numeroSalas="numeroSalas"
                            :horarioClinica="sala.horarioClinica"
                            :horarioClinica1="sala.horarioClinica1"
                            :horarioClinicaUnico="sala.horarioClinicaUnico"
                            :idEspecialidadFiltro="idEspecialidadFiltro"
                    />

                  </div>
                </td>
              </tr>
            </table>
          </div>
        </td>
      </tr>

    </table>

  </div>
</template>

<script>

export default {
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    numeroSalas: undefined,
    dias: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miercoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ],
    semana: {},
    casillas: [],
    fechaInicio: undefined,
    fechaFin: undefined,

    casillasSalas: [],
  }),
  props: {
    idEspecialidadFiltro: Number,
  },
  computed: {
    ancho() {
      if (this.numeroSalas <= 4) {
        return "width:30px;";
      } else {
        return "width:" + (130 / (this.numeroSalas +2)) + "px; font-size:8px;";
      }
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {

    pintarEventos(val) {

        this.semana.horas.forEach((hora) => {
          this.casillas[hora.posicion].forEach((casilla) => {
            casilla.salas.forEach((sala) => {
              
              const indiceBase = this.$moment(casilla.fechaCasilla).format('YYYY/MM/DD')+'-'+casilla.horaCasilla1 +'-'+ (sala.numeroSala);

              //Verificamos los horarios normales
              let indiceCasilla = indiceBase+'-false';
              if (val[indiceCasilla] !== undefined) {
                sala.horarioClinica = val[indiceCasilla];

              }

              //Verificamos los horarios unicos
              indiceCasilla = indiceCasilla+'-5';
              if (val[indiceCasilla] !== undefined) {
                sala.horarioClinicaUnico = val[indiceCasilla];
              }

              //Verificamos los horarios bloqueo
              indiceCasilla = indiceBase+'-true';
              if (val[indiceCasilla] !== undefined) {
                sala.horarioClinica1 = val[indiceCasilla];
              }
              
            });
          });
        });

      this.casillasSalas = Array();

      let contador = 1;
      for (let i = 0; i < this.numeroSalas; i++) {
        this.casillasSalas.push(contador++);

        if (contador > this.numeroSalas) {
          contador = 1;
        }
      }
    },

    cambiarAnteriorSemana() {
      let fecha = new Date(this.fechaInicio);
      fecha.setDate(fecha.getDate() - 7);
      this.$emit("seleccionarFecha", fecha);
    },

    cambiarSiguienteSemana() {
      let fecha = new Date(this.fechaInicio);
      fecha.setDate(fecha.getDate() + 7);
      this.$emit("seleccionarFecha", fecha);
    },

    calcularSemana(fechaRecibida, eventos, numero) {
      let fecha = new Date();
      fecha = new Date(fechaRecibida.toISOString());

      this.numeroSalas = numero;

      this.semana = {};

      const mesSemana = this.$moment(fecha.toISOString()).format("MMMM YYYY");

      this.semana.numeroSemana = "Semana " + this.$moment(fecha.toISOString()).week() + " (" + mesSemana.charAt(0).toUpperCase() + mesSemana.slice(1) + ")";

      this.semana.dias = Array();
      fecha.setDate(fecha.getDate() - fecha.getDay());

      this.fechaInicio = this.$moment(fecha.toISOString()).format("YYYY/MM/DD");
      this.llenarCasillas(fecha);

      for (let i = 0; i < 7; i++) {
        this.semana.dias.push({
          fecha: new Date(fecha),
          diaEtiqueta: this.dias[fecha.getDay()] + " " + this.$moment(fecha.toISOString()).format("DD"),
          diaNumero: fecha.getDay(),
        });
        fecha.setDate(fecha.getDate() + 1);
      }

      this.fechaFin = this.$moment(fecha.toISOString()).format("YYYY/MM/DD");

      this.pintarEventos(eventos);
    },

    calcularHoras() {
      this.semana.horas = Array();
      let fecha = new Date();
      fecha.setHours(7);
      fecha.setMinutes(0);
      fecha.setMilliseconds(0);

      for (let i = 0; i < 69; i++) {
        this.semana.horas.push({
          posicion: i,
          horaEtiqueta: this.$moment(fecha.toISOString()).format("HH:mm"),
          horaEtiqueta1: this.$moment(fecha.toISOString()).format("HHmm"),
        });

        fecha.setMinutes(fecha.getMinutes() + 15);
      }
    },

    llenarCasillas(fechaInicio) {
      this.calcularHoras();
      this.casillas = Array();

      const diaActual = this.$moment().format('YYYY-MM-DD');

      this.semana.horas.forEach((horaSemana) => {
        const fechaCasilla = new Date();
        fechaCasilla.setTime(fechaInicio.getTime());
        const casillas = Array();
        for (let i = 0; i < 7; i++) {

          const fechaCasillaFormato = this.$moment(fechaCasilla.toISOString()).format('YYYY-MM-DD');


          casillas.push({
            diaSemana: i,
            horaCasilla: horaSemana.horaEtiqueta,
            horaCasilla1: horaSemana.horaEtiqueta1,
            fechaCasilla: this.$moment(fechaCasilla.toISOString()).format("YYYY-MM-DD"),
            esfechaActual:  fechaCasillaFormato === diaActual,
            salas: this.llenarSalas(),
          });

          fechaCasilla.setDate(fechaCasilla.getDate() + 1);
        }

        this.casillas.push(casillas);
      });
    },

    llenarSalas() {
      const salas = Array();
      for (let i = 0; i < this.numeroSalas; i++) {
        salas.push({
          numeroSala: i + 1,
          horarioClinica: undefined,
        });
      }

      salas.push({
        numeroSala: 100,
        cita: undefined,
        color: "inherit"
      })

      salas.push({
        numeroSala: 101,
        cita: undefined,
        color: "inherit"
      })

      return salas;
    },

    consultarDetalle(horarioClinica) {
      this.$emit("consultarDetalle", horarioClinica);
      
    },

    activarDesactivarHorario(horario) {
      this.$emit("activarDesactivarHorario", horario);
    },

    bloquear(horario) {
      this.$emit("bloquear", horario);
    },

    desbloquear(horario) {
      this.$emit("desbloquear", horario);
    },
    reasignarDoctor(horario) {
      this.$emit("reasignarDoctor", horario);
    },
    estiloLineaHora(hora) {
      if (hora === undefined || hora === null || hora.horaEtiqueta === undefined || hora.horaEtiqueta === null) {
        return "";
      }
      const cadenas = hora.horaEtiqueta.split(":");
      if (cadenas[1] === "00") {
        return "border-top-width: 2px;border-top-color: #939393;";
      }

      return "";
    }
  },
};
</script>

<style scoped>
  .titulo {
    background-color: rgba(0, 0, 0, .1);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    font-size: 1.4em;
    line-height: 1.3;
    min-height: 2em;
    width: 100%;
    user-select: none;
  }

  .titulo span {
    position: relative;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  button:not(:disabled),
  [type="button"]:not(:disabled),
  [type="reset"]:not(:disabled),
  [type="submit"]:not(:disabled) {
    cursor: pointer;
  }

  .horas {
    color: #c9c9c9;
  }

  .casilla {
    border: #c9c9c9 solid 1px;
    height: 20px;
  }
</style>
